export class ForgotPasswordFieldError extends Error {
  readonly field = 'email' as const;

  constructor(message: string) {
    super(message);
    this.name = 'ForgotPasswordFieldError';
  }
}

export type ForgotPasswordResult = {
  status: 'navigated' | 'google_account' | 'user_not_found';
};
